/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBrief } from './companyBrief';
import { BankBrief } from './bankBrief';


export interface CompanyAccount { 
    id: number;
    code: string;
    description?: string | null;
    currencyId?: number | null;
    currencyString: string;
    bank: BankBrief;
    company: CompanyBrief;
    designation: string;
    transitId: number;
    obscureId: number;
    nostroTransitId: number;
    instrumentId: number;
    isClosed: boolean;
}

